import styled from "styled-components"
import ControlContainer from "../../components/nakliyeHesaplama/mainContainers/ControlContainer"
import MapContainer from "../../components/nakliyeHesaplama/mainContainers/MapContainer"
import RouteControlContainer from "../../components/nakliyeHesaplama/mainContainers/RouteControlContainer"
import { useDispatch } from "react-redux"
import { useEffect, useRef } from "react"
import { useSelector } from "react-redux"
import { getNakliyeHesaplama, setControlContainer, setIsCenterResultContainer, setRouteControlContainer } from "../../features/nakliyeHesaplama/nakliyeHesaplamaSlice"
import { getCurrentYakitFiyat, getFeribotUcret, getKopruGemiUcret } from "../../features/calc/calcSlice"
import ExtraResultContainer from "../../components/nakliyeHesaplama/mainContainers/ExtraResultContainer"

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    width: calc(100vw - 80px);
    height: 100vh;

    .center-container{
      width: ${({isControlContainerOpen, isRouteControlContainerOpen}) =>
      (isRouteControlContainerOpen && isControlContainerOpen) ? "calc(100% - 720px)" :
      ((isRouteControlContainerOpen && !isControlContainerOpen) || (!isRouteControlContainerOpen && isControlContainerOpen)) ? "calc(100% - 360px)" : "100%" } ;
      height: 100%;
      overflow: hidden;
    }

`

const NakliyeHesaplama = () => {

  const dispatch = useDispatch()

  const containerRef = useRef()

  const {
    truckType,
    route,
    kmData,
    tonajData,
    jobDuration,
    isControlContainerOpen,
    isRouteControlContainerOpen,
    isCenterResultContainerOpen,
    isDurationStrict,
    selectedRouteItem
  } = useSelector(state => state.nakliyeHesaplama)


  const {
    yakitData
  } = useSelector(state => state.calc)

  useEffect(() => {
    getNakliyeHesaplamaRequest()
  },[truckType?.id, route, yakitData, kmData, tonajData.value])


  const getNakliyeHesaplamaRequest = () => {

    const filledRoutePoints = route.filter(item => {
      return item.lat && item.lng
    }) 
    
    

    const lastRoutePoint = filledRoutePoints.findLast(item => {
      return item.lat && item.lng
    }) 

    if(
      truckType?.id &&
      route[0]?.cityId &&
      yakitData &&
      kmData &&
      filledRoutePoints.length > 1 &&
      tonajData.value &&
      lastRoutePoint?.lat &&
      lastRoutePoint?.lng
    ){

      const body = {
        aracTuru: truckType?.id,
        nerden: parseInt(route[0]?.cityId),
        nereye: parseInt(route[route.length - 1]?.cityId),
        km: parseInt(selectedRouteItem?.distanceMeters / 1000),
        tonaj: tonajData.value,
        isKacGunSürecek: jobDuration || 1,
        //!
        guncelYakitFiyati: yakitData,
        districtMernisCode: lastRoutePoint?.mernis || lastRoutePoint?.townId,
        nereyeLat: parseFloat(lastRoutePoint?.lat),  
        nereyeLng: parseFloat(lastRoutePoint?.lng),
        isWebPanel: true,
        isDurationStrict,
        intermediatesLength: filledRoutePoints.filter((item,i) => {
          return i !== 0 && i+1 !== filledRoutePoints.length && item.isStopOver
        }).length
      }

      dispatch(getNakliyeHesaplama(body))
    }
  }


  const handleKeyPress = (e) => {

    if(e.key.toLowerCase() === "w"){
      if(isControlContainerOpen || isRouteControlContainerOpen || isCenterResultContainerOpen){
        dispatch(setControlContainer(false))
        dispatch(setRouteControlContainer(false))
        dispatch(setIsCenterResultContainer(false))
      }

      else if(!isControlContainerOpen && !isRouteControlContainerOpen && !isCenterResultContainerOpen){
        dispatch(setControlContainer(true))
        dispatch(setRouteControlContainer(true))
        dispatch(setIsCenterResultContainer(true))
      }

      else if(isControlContainerOpen && isRouteControlContainerOpen && isCenterResultContainerOpen){
        dispatch(setControlContainer(false))
        dispatch(setRouteControlContainer(false))
        dispatch(setIsCenterResultContainer(false))
      }

      else{
        dispatch(setControlContainer(true))
        dispatch(setRouteControlContainer(true))
        dispatch(setIsCenterResultContainer(true))
      }
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [isRouteControlContainerOpen, isControlContainerOpen, isCenterResultContainerOpen]);


    //! apiden çekilen veriler
    useEffect(() => {
      dispatch(getKopruGemiUcret());
      dispatch(getFeribotUcret());
      dispatch(getCurrentYakitFiyat());
  
      return () => {
        //! buraya sıfırlama gelecek
      };
    }, []);

  return (
    <Container isControlContainerOpen={isControlContainerOpen} isRouteControlContainerOpen={isRouteControlContainerOpen} ref={containerRef}>
        <ControlContainer/>
        <div className="center-container">
          <MapContainer/>
          <ExtraResultContainer/>
        </div>
        <RouteControlContainer/>
    </Container>
  )
}

export default NakliyeHesaplama